import { VStack, StackProps, Text, HStack } from '@chakra-ui/react';
import { ChakraLink } from 'app/components/Core';
import { FC } from 'react';

interface AuthFormFooterProps extends StackProps {
  link?: {
    label: string;
    path: string;
    search?: string;
  };
}

export const AuthFormFooter: FC<AuthFormFooterProps> = ({
  children,
  link,
  ...rest
}) => {
  return (
    <VStack
      borderTop="1px solid"
      borderColor="M.30"
      w="full"
      mx="auto"
      {...rest}
    >
      <HStack
        mx="auto"
        pt={8}
        fontWeight={400}
        fontSize="sm"
        letterSpacing="0.25px"
      >
        <Text lineHeight="17px">{children}</Text>
        {link && (
          <ChakraLink
            to={{
              pathname: link.path,
              search: link.search,
            }}
          >
            {link.label}
          </ChakraLink>
        )}
      </HStack>
    </VStack>
  );
};
